import { useUniqueFieldSuffix } from "../contexts/unique-field-suffix-context.js";
function getInputId(fieldId, uniqueId) {
  return `form-field-input-${fieldId}-${uniqueId}`;
}
function getLabelId(fieldId, uniqueId) {
  return `form-field-label-${fieldId}-${uniqueId}`;
}
function getPrefixId(fieldId, uniqueId) {
  return `form-field-prefix-${fieldId}-${uniqueId}`;
}
function getDescriptionId(fieldId, uniqueId) {
  return `form-field-description-${fieldId}-${uniqueId}`;
}
function getErrorId(fieldId, uniqueId) {
  return `form-field-error-${fieldId}-${uniqueId}`;
}
function getAriaDescribedBy(errorId, descriptionId, error, description) {
  return [error && errorId, description && descriptionId].filter(Boolean).join(" ") || void 0;
}
function getErrorDataHook(target) {
  return `field-error-${target}`;
}
function useFieldAttributes(fieldId, error, description) {
  const uniqueId = useUniqueFieldSuffix();
  const errorId = getErrorId(fieldId, uniqueId);
  const descriptionId = getDescriptionId(fieldId, uniqueId);
  return {
    inputId: getInputId(fieldId, uniqueId),
    labelId: getLabelId(fieldId, uniqueId),
    prefixId: getPrefixId(fieldId, uniqueId),
    descriptionId,
    errorId,
    ariaDescribedBy: getAriaDescribedBy(
      errorId,
      descriptionId,
      error,
      description
    )
  };
}
export {
  getAriaDescribedBy,
  getDescriptionId,
  getErrorDataHook,
  getErrorId,
  getInputId,
  getLabelId,
  getPrefixId,
  useFieldAttributes
};
//# sourceMappingURL=field-attributes.js.map
